import { useI18n as useVueI18n } from 'vue-i18n';
import { useTranslationStore } from '@/stores/translation';

export function useI18n() {
  const { t, d } = useVueI18n({ useScope: 'global' });
  const translationStore = useTranslationStore();

  const formatDate = (val: string | Date | null | undefined): string => {
    if (!val) return '—';
    return new Date(val).toLocaleString(translationStore.currentLanguage);
  };

  return {
    t,
    d,
    formatDate,
  };
}
